import React from "react"
import { StyleAndConfigurationSubpath } from "sharedTypes"
import SettingsSection from "components/settings/SettingsSection"
import { useEventStyleAndConfigurationPath } from "utilities/routes"
import useFeatureFlag from "services/featureFlags"
import RoundedList from "../RoundedList"
import LinkListItem from "../LinkListItem"

type Props = {
  eventId: string
}

const RelatedSettings = ({ eventId }: Props) => {
  const styleAndConfigurationPath = useEventStyleAndConfigurationPath()
  const { vanityUrls: vanityUrlsEnabled } = useFeatureFlag()

  return (
    <SettingsSection title="Related Settings">
      <RoundedList>
        <LinkListItem
          title={vanityUrlsEnabled ? "Automated Emails" : "Email Responders"}
          description="Customize confirmation emails and control QR code visibility for guests who register."
          to={styleAndConfigurationPath(
            eventId,
            StyleAndConfigurationSubpath.EmailResponders,
          )}
        />
      </RoundedList>
    </SettingsSection>
  )
}

export default RelatedSettings
